import { bannerZoneServices } from './Services/bannerZoneServices.service';
import { Component, HostListener, OnInit, ViewChild, Inject, Renderer2, ElementRef, AfterViewInit, ViewEncapsulation, HostBinding } from "@angular/core";
import { slideInAnimation } from "./animations";
import { RouterOutlet, Router, NavigationEnd } from "@angular/router";
import { MainService } from "./Services/service.service";
import { SearchSmallComponent } from "./Adv/search-small/search-small.component";
import { VersionCheckService } from "./Services/version-check.service";
import { TokenExpiredDialogComponent } from "./Dialogs/token-expired-dialog/token-expired-dialog.component";
import { MatDialog } from "@angular/material";
import { NewVersionDialogComponent } from "./Dialogs/new-version-dialog/new-version-dialog.component";
import { DOCUMENT } from "@angular/common";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { AdsClient } from "./api/WickedApiClient";
import { SeoService } from "./Services/seo.service";
import { filter } from "rxjs/operators";
import { GoogleAnalyticsService } from "./Services/google.analytics.service";


declare var ga: Function;

declare var content: string;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  animations: [slideInAnimation],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit, AfterViewInit {
  
  title = "WL";

  seoUrlsMap = [];

  citiesUrlMap = ["/nm-albuquerque", "/ga-atlanta", "/tx-austin", "/ca-bakersfield", "/md-baltimore", "/al-birmingham", "/ny-bronx", "/ny-brooklyn", 
  "/ny-buffalo", "/nc-charlotte", "/il-chicago", "/oh-cincinnati", "/oh-cleveland", "/co-colorado-springs", "/oh-columbus", "/tx-dallas", "/oh-dayton", 
  "/co-denver", "/mi-detroit", "/tx-el-paso", "/fl-fort-lauderdale", "/tx-fort-worth", "/ca-fresno", "/tx-houston", "/in-indianapolis", "/fl-jacksonville", 
  "/mo-kansas-city", "/nv-las-vegas", "/ca-long-beach", "/ca-los-angeles", "/ky-louisville", "/tn-memphis", "/az-mesa", "/fl-miami", "/wi-milwaukee", 
  "/mn-minneapolis", "/tn-nashville", "/ny-new-york", "/ok-oklahoma-city", "/ne-omaha", "/fl-orlando", "/pa-philadelphia", "/az-phoenix", "/pa-pittsburgh", 
  "/or-portland", "/nc-raleigh", "/ny-rochester", "/ca-sacramento", "/mo-saint-louis", "/mn-saint-paul", "/ut-salt-lake-city", "/tx-san-antonio", 
  "/ca-san-diego", "/ca-san-francisco", "/ca-san-jose", "/wa-seattle", "/ny-staten-island", "/fl-tampa", "/az-tucson", "/dc-washington"];

  categoriesUrlMap = [ "women-seeking-men", "women-seeking-women", "women-seeking-couples", "women-seeking-transgenders", "men-seeking-women", "men-seeking-men", "men-seeking-couples", "men-seeking-transgenders", "couples-seeking-women", "couples-seeking-men", "couples-seeking-couples", "couples-seeking-transgenders", "transgenders-seeking-women", "transgenders-seeking-men", "transgenders-seeking-couples", "transgenders-seeking-transgenders", "missed-connections"];
  

  @ViewChild(SearchSmallComponent, { read: null, static: false }) searchSmall: SearchSmallComponent

  constructor(public services: MainService, private router: Router, private versionCheck: VersionCheckService, public dialog: MatDialog, protected sanitizer: DomSanitizer, protected adClient: AdsClient, private seo: SeoService, googleAnalyticsEventsService: GoogleAnalyticsService, public bannersService:bannerZoneServices) {
    // merge two urls arrays
    this.seoUrlsMap = this.citiesUrlMap.concat(this.categoriesUrlMap);

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      ga('set', 'page', event.urlAfterRedirects);
      ga('send', 'pageview');
      const forCurrentUrl = this.urlIsForStaticChanges(event.url)
      this.seo.removeCanonicalLink();
      if(forCurrentUrl.isContain){
        if(forCurrentUrl.mainUrl != event.url){
          if (forCurrentUrl.mainUrl.charAt(0) == '/')
          {
              //is property link
              this.seo.updateCanonicalLink(forCurrentUrl.mainUrl)
          }
        }
        this.seo.getMetaSeo(event.url.replace("/", "")).then((metaSeoTags)=>{
          this.seo.updateMeta(metaSeoTags.metaTitle, metaSeoTags.metaDescription);
        });
      }
      else if (event.url != "/search-results") {
        this.seo.updateMetaDefaults();
      }
    });
  }
  urlIsForStaticChanges(currentUrl){
    let tmpUrl = "";
    const isContain = this.seoUrlsMap.some((item)=>{
      if(currentUrl.includes(item)){
        tmpUrl = item;
        return true;
      }
    })
    return {isContain, mainUrl: tmpUrl};
  }

  @HostBinding('class.premium-account') get isPremium(): boolean {
    return this.services.userService.isPremium();
  }

  getAnimationData(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData["animation"];
  }



  ngOnInit() {
    this.versionCheck.versionChanged.subscribe((changed) => {
      if (changed) {
        const dialogRef = this.dialog.open(NewVersionDialogComponent, {
          autoFocus: true,
          hasBackdrop: true,
          disableClose: true,
          data: {},
        });
      }
    });
    this.bannersService.getAllUserBaners();
  }

  ad1: SafeHtml;
  ad2: SafeHtml;
  ad3: SafeHtml;

  ngAfterViewInit() {
    let premium = this.services.userService.isPremium();

   

  }

  isSticky: boolean = false;

  //@HostListener('window:scroll', ['$event'])
  //checkScroll() {
  //  this.isSticky = window.pageYOffset >= 100;
  //}

  public get currentUrl() {
    return this.services.route.url;
  }


  public get canShowSearchForm() {

    return true;//this.currentUrl=='search-results';
  }

  onUserLogout() {
    this.searchSmall.clearSearch();
  }
}
